module.exports = __webpack_public_path__ + "img/a3.caee6363.png";